import { useQuery } from '@tanstack/vue-query'

import { useOtherService, useSanctumService } from '~/core/services'

const staleTime = 24 * 60 * 60 * 1000 // 24H
export const useAppInit = () => {
  const { getPrerequisite } = useOtherService()
  const { getCsrfCookie } = useSanctumService()

  const { data: prerequisite, suspense: suspensePrerequisite, isFetching: isFetchingPrerequisite } = useQuery({
    queryKey: ['common', 'prerequisite'],
    queryFn: getPrerequisite,
    staleTime,
  })

  const { isFetching: isFetchingCsrf } = useQuery({
    queryKey: ['csrf-cookie'],
    queryFn: getCsrfCookie,
    staleTime,
  })

  const isFetching = computed(() => isFetchingCsrf.value || isFetchingPrerequisite.value)
  const prices = computed(() => prerequisite.value?.data?.ranges ?? { min: 0, max: 0 })

  return {
    suspensePrerequisite,
    prerequisite,
    isFetching,
    prices,
  }
}
